export const navigation = {
    methods: {
        navigateToRoute(route) {
            if (route.name != this.$route.name) {
                this.$router.push(route);
            }
        },
    }
}
